import axiosInstance from "./AxiosInstance";

export function addJobFair(data) {
  return axiosInstance.post("/admin/candidate/job-fair-events", data);
}

export function updateJobFair(id, data) {
  return axiosInstance.put("/admin/candidate/job-fair-events/" + id, data);
}

export function deleteJobFair(event_id) {
  return axiosInstance.post("admin/candidate/delete-job-fair", { event_id });
}

export function getJobFairList(data) {
  return axiosInstance.post("/admin/candidate/job-fair-events/listing", data);
}

export function getJobFair(id) {
  return axiosInstance.get("/admin/candidate/job-fair-events/" + id);
}

export function getJobFairOption(data) {
  return axiosInstance.get("/admin/candidate/job-fair/listing", data);
}

export function updateVerificationSatus(data) {
  return axiosInstance.post(
    "/admin/candidate/job-fair/update-call-status",
    data
  );
}

export function updateCallSatus(data) {
  return axiosInstance.post("/admin/user/update-call-status", data);
}

export function getMatchedCandidate(data) {
  return axiosInstance.post(
    "/admin/candidate/job-fair/matched-candidates",
    data
  );
}

export function sendEventEmail(data) {
  return axiosInstance.post("/admin/candidate/job-fair/track-email", data);
}
